import * as types from 'modules/selfServices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export const initialState = null;

/**
 * @param {string} _
 * @param {import('modules/selfServices/types').OpenSendWizardAction} action
 * @returns {string}
 */
const setInterventionId = (_, { payload: { interventionId } }) => interventionId;

/** @returns {string} */
const reset = () => initialState;

export default createReducer(initialState, {
  [types.CLOSE_SEND_WIZARD]: reset,
  [types.OPEN_SEND_WIZARD]: setInterventionId,
});
